export const OrganisationClass = {
    STARTER: 'STARTER',
    IGNITE: 'IGNITE'
};
